export const GLOBAL_URL = 'https://easycalls.in:3000'
// export const GLOBAL_URL = 'https://dev.easycalls.in:3036'

